module.exports = __webpack_public_path__ + "static/media/T-warning.240aea43.svg";